
import React from 'react';
import MemoryHelp from '../../components/MemoryHelp/MemoryHelp';
import '../../components/MemoryHelp/MemoryHelp.scss';

export const MemoryHelpPage = ({ handleOnClick }) => <MemoryHelp navigate={handleOnClick} />;
